import styled from 'styled-components';
import { breakpoints } from 'assets/breakpoints';

export const Title = styled.h1`
  font-family: Helvetica,serif;
  letter-spacing: -1.65px;
  font-size: 55px;
  color: white;
  font-weight: 100;
  margin: 0;
`;

export const Highlight = styled.span`
  color: #fe1016;
`;

export const Logo = styled.img`
  border: 0;
  width: 200px;
  
  @media (min-width: ${breakpoints.desktop}) {
    width: 400px;
  
  }
  
`;
